import React, { useEffect, useState } from 'react';
import { Col, Form, FormGroup, Label, Row } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import ValidatedInput from "../../../components/ValidatedInput";
import { addPhone, resetFlags } from "../../../redux/actions/AuthAction";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const VerifyPhone = ({ authFlags, authErrors, addPhone, resetFlags, history, handleSubmit }) => {
    const [processing, setProcessing] = useState(false);

    useEffect(() => {
        if (authErrors && authErrors.addPhone) {
            toast.error(authErrors.addPhone);
            setProcessing(false);
            resetFlags();
        }

        if (authFlags && authFlags.addPhoneSuccess) {
            resetFlags();
            history.push('/verify-code');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authErrors, authFlags]);



    const handleAddPhone = (formData) => {
        const { phone_number } = formData;
        setProcessing(true);
        addPhone({ phone_number });
    };

    return (
        <div className="account-setup-wrapper">
            <Form className="form-container" onSubmit={handleSubmit(handleAddPhone)}>
                <div className="form-header mt-md-3 mt-0 form-group-center">
                    <h2 className="text-center">Verify your phone number</h2>
                    <span>For your security, please verify your US phone number. A code will be sent to:</span>
                </div>
                <FormGroup className="form-group-center">
                    <Row>
                        <Label sm={4}>Phone</Label>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Field component={ValidatedInput} type="phone" name="phone_number" prefix="+1" />
                        </Col>
                    </Row>
                </FormGroup>
                <div className="button_wrapper">
                    <button className="btn button" type="submit" disabled={processing}>
                        SEND CODE {processing && <FontAwesomeIcon icon={faSpinner} spin />}
                    </button>
                </div>
                <div className="links-forgot">
                    <a href="#/">Don't have a US Phone Number?</a>
                </div>
            </Form>
        </div>
    )
};

const validate = (values) => {
    const errors = {};
    if (!values.phone_number) {
        errors.phone_number = 'Field is required';
    }
    if (values.phone_number && !/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/i.test(values.phone_number)) {
        errors.phone_number = 'Invalid phone number';
    }
    return errors;
};

const mapStateToProps = state => ({
    authErrors: state.Auth.errors,
    authFlags: state.Auth.flags,
});

const mapDispatchToProps = dispatch => ({
    addPhone: payload => {
        dispatch(addPhone(payload))
    },
    resetFlags: payload => {
        dispatch(resetFlags())
    }
});

const VerifyPhoneComponent = connect(
    mapStateToProps,
    mapDispatchToProps
)(VerifyPhone);

export default reduxForm({
    form: 'VerifyPhoneForm',
    validate,
})(VerifyPhoneComponent);
